import { Dayjs } from 'dayjs';

import { assignSafe, SBaseDisplay } from '@summit/core';
import { SMapMarker } from '@summit/maps';
import { OdometerFormatter } from '@summit/models';

import { EPosition } from '@summit/models';
import { EboEvent } from '../../base-classes/ebo-event';
import { Plot } from '../../places/properties/plot';
import { State } from '../../places/state/state';
import { TruckAlias } from '../truck-alias';
import { OdometerEstimationMethod } from './odometer-estimation-method.enum';
import { PositionReportFlags } from './position-report-flags.enum';
import { PositionSource } from './position-source.enum';

export class PositionReport extends EboEvent implements SBaseDisplay {
  name: string;
  truckAliasID: string;
  truckAlias: TruckAlias;
  ignitionOn: boolean;
  speed: number;
  heading: number;
  odometer: number;
  point: EPosition;
  source: PositionSource;
  flags: PositionReportFlags;
  fedExID1: string;
  fedExID2: string;
  stateId: string;
  state: State;
  // stateStartTime: Dayjs;
  // enteringStateId: string;
  // enteringState: State;
  roadName: string;
  estimationMethod: OdometerEstimationMethod;
  estimatedOdometer: number;
  propertyId: string;
  property: Plot;

  constructor(jsonData?: Partial<PositionReport>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.truckAlias) this.truckAlias = new TruckAlias(jsonData.truckAlias);
      if (jsonData.point) this.point = new EPosition(jsonData.point);
      if (jsonData.state) this.state = new State(jsonData.state);
      // if (jsonData.enteringState) this.enteringState = new State(jsonData.enteringState);
      // if (jsonData.stateStartTime) this.stateStartTime = SDate.newUtc(jsonData.stateStartTime);
      if (jsonData.property) this.property = new Plot(jsonData.property);
    }
  }

  toSMapMarker(base?: Partial<SMapMarker>): SMapMarker {
    const lclMarker = {
      title: this.name,
      point: new EPosition(this.point)
    };
    if (base) assignSafe(lclMarker, base);
    return new SMapMarker(lclMarker);
  }

  private _dateStart: Dayjs;
  get dateStart(): Dayjs {
    if (!this._dateStart) this._dateStart = this.eventDate.startOf('day');
    return this._dateStart;
  }

  private _odometerFormatted: string;
  get odometerFormatted(): string {
    if (!this._odometerFormatted) {
      this._odometerFormatted = this.odometer ? OdometerFormatter(this.odometer) : null;
    }
    return this._odometerFormatted;
  }

  private _toShortString: string;
  toShortString(): string {
    if (!this._toShortString) {
      this._toShortString = `${this.name}-${this.eventDate.format('MM/DD/YY-HH:mm:SS')}`;
    }
    return this._toShortString;
  }

  HasFlag(flag: PositionReportFlags): boolean {
    // eslint-disable-next-line no-bitwise
    return flag === (this.flags & flag);
  }

  SetFlag(flag: PositionReportFlags, value: boolean) {
    if (value) {
      // eslint-disable-next-line no-bitwise
      this.flags |= flag;
    } else {
      // eslint-disable-next-line no-bitwise
      this.flags &= ~flag;
    }
  }
}
